import React, { FC } from 'react';

import { SharedPartnerConditionProps } from '../../PartnerRules/types';
import { SharedConditionProps } from '../../types';
import { PartnerDetailSelect } from '../components/PartnerDetailSelect';
import { PartnerOptionSelect } from '../components/PartnerOptionSelect';
import { PartnerSelect } from '../components/PartnerSelect';

export const PartnerDetailHasKey: FC<
  SharedConditionProps | SharedPartnerConditionProps
> = props => {
  return (
    <>
      {!props.setPartnerRules && <PartnerSelect {...props} />}
      <PartnerDetailSelect {...props} />
      {!props.setPartnerRules && <PartnerOptionSelect {...props} />}
    </>
  );
};
